import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgObsolete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 400 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M400 144H256V0l144 144zM84 318l108-52 133 53 75-42V176H224V0H0v269l84 49zm120 194h195V369l-68 38-136-54-114 55-81-47v151h204z" })
});
export default SvgObsolete;
